export enum HblViewTabs {
  Details = 'HBL DETAILS',
  Milestones = 'MILESTONES',
  Charges = 'CHARGES',
  Attachments = 'ATTACHMENTS',
  Photos = 'PHOTOS',
  ItApplication = 'In Bond',
  Print = 'Print',
}
